enum StandingOrderType {
  PAYMENT_ORDER = 'PAYMENT_ORDER',
  TRANSFER_ORDER = 'TRANSFER_ORDER',
  SAVINGS_ORDER = 'SAVINGS_ORDER',
  FUNDS_ORDER = 'FUNDS_ORDER',
}

export default StandingOrderType;
